import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: {
        //Navbar
        dashboard: 'Dashboard',
        language: 'Language',
        logout: 'Logout',
        course: 'Courses',
        profile: 'Profile',
        schedule: 'Schedule',

        //Home
        search: 'Search',
        location: 'Location',
        startDate: 'Start Date',
        endDate: 'End Date',
        startTime: 'Start Time',
        endTime: 'End Time',
        price: 'Price',
        courses: 'Courses',
        submit: 'Submit',

        //Profile
        name: 'Name',
        email: 'Email',
        phno: 'Phone number',
        address: 'Address',
        pincode: 'Pincode',
        gender: 'Gender',
        dob: 'Date of Birth',
        enterPassword: 'Enter new password:',
        password: 'password',
        resetPassword: 'Change Password',
        certNo: 'Certificate No', // -------------------New
        contactPerson: 'Contact',
        contactNo: 'Contact Number',
        createdAt: 'Created date',
        edit: 'edit',
        delete: 'delete',

        //Login
        close: 'Close',
        login: {
            email: 'Email',
            password: 'Password',
            loginBtn: 'Login',
            type: 'Centre de formation'
        },

        connexion: {
            email: 'Email',
            password: 'password',
            type: 'Training center connexion'
        }
    },
    fr: {
        //Navbar
        dashboard: 'Tableau de bord',
        language: 'Langue',
        logout: 'Déconnexion',
        course: 'Stages',
        profile: 'Profil',
        schedule: 'programme',

        //Home
        search: 'Rechercher',
        location: 'Lieu',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        startTime: 'Heure de début',
        endTime: 'Heure de fin',
        price: 'Prix',
        courses: 'Stages',
        submit: 'Soumettre',

        //Profile
        name: 'Nom',
        email: 'Email',
        phno: 'Téléphone',
        address: 'Adresse',
        pincode: 'Code postal',
        gender: 'Le genre',
        dob: 'Date de naissance',
        enterPassword: 'Entrez un nouveau mot de passe:',
        password: 'Mot de passe',
        resetPassword: 'Changer le mot de passe',
        certNo: 'Numéro de certificat', // ------------------------New
        contactPerson: 'Contact',
        contactNo: 'Numéro de contact',
        createdAt: 'Date de création',
        edit: 'Éditer',
        delete: 'Supprimer',

        close: 'Fermer',

        login: {
            email: 'Email',
            password: 'Mot de passe',
            loginBtn: 'Se connecter',
            type: 'Centre de formation'
        },
        cancel: 'Annuler',
        clear: 'Éffacer',
        create: 'Créer',
        yes: 'Oui',
        no: 'Non',
        today: "Aujourd'hui",
        day: 'Jours',
        week: 'Semaine',
        month: 'Mois'
    }
};

export const i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages
});